export default __webpack_public_path__ + "static/media/landing_section_1.dc274bb8.svg";